"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthenticator = void 0;
var MbAuthenticator_1 = require("./MbAuthenticator");
Object.defineProperty(exports, "MbAuthenticator", { enumerable: true, get: function () { return MbAuthenticator_1.MbAuthenticator; } });
//# sourceMappingURL=index.js.map